import "../styles/Logo.scss";
import useLightbox from "../hooks/useLightbox";
import Zoom from "react-reveal/Zoom";
import logos from "../assets/logo.gif";
import img1 from "../assets/logos/abilis.png";
import img2 from "../assets/logos/adeva.png";
import img3 from "../assets/logos/beauty-weeks.png";
import img4 from "../assets/logos/bushcraft.png";
import img5 from "../assets/logos/buzzz.png";
import img6 from "../assets/logos/eyeka.jpg";
import img7 from "../assets/logos/lawebbisterie.png";
import img8 from "../assets/logos/oceansfishing.jpg";
import img9 from "../assets/logos/revanove.jpg";
import img10 from "../assets/logos/sylmaps.png";
import img11 from "../assets/logos/triviacar.png";
import img12 from "../assets/logos/wahine-way.jpg";
import img13 from "../assets/logos/logo-le-cocon.png";
import img14 from "../assets/logos/logo-roundnet.png";
import img15 from "../assets/logos/fast-tips.jpg";
import img16 from "../assets/logos/e-rando.jpg";
import img17 from "../assets/logos/trace-media.jpg";
import img18 from "../assets/logos/tonton-happy.jpg";
import img19 from "../assets/logos/delta-dep.jpg";
import img20 from "../assets/logos/confiserie-delgado.jpg";

const shuffle = (arr) => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

const ALL_LOGOS = shuffle([
  { img: img1,  title: "Abilis" },
  { img: img2,  title: "Adeva" },
  { img: img3,  title: "Beauty Weeks" },
  { img: img4,  title: "Bushcraft Le Blog" },
  { img: img5,  title: "Agence Buzzz" },
  { img: img6,  title: "eyeka" },
  { img: img7,  title: "La Webbisterie" },
  { img: img8,  title: "Oceansfishing" },
  { img: img9,  title: "Revanove" },
  { img: img10, title: "Sylmaps" },
  { img: img11, title: "Triviacar" },
  { img: img12, title: "Wahine Way" },
  { img: img13, title: "Le Cocon" },
  { img: img14, title: "Roundnet" },
  { img: img15, title: "Fast Tips" },
  { img: img16, title: "E-Randos" },
  { img: img17, title: "Trace Media" },
  { img: img18, title: "Tonton Happy Tattoo Shop" },
  { img: img19, title: "Delta D.E.P" },
  { img: img20, title: "Confiserie Delgado" },
]);

const Logo = () => {
  const { lightbox, visible, openLightbox, closeLightbox } = useLightbox();

  return (
    <div className="boxLogo">
      <section id="sectionLogo"></section>
      <div className="boxTitle">
        <img src={logos} alt="imgLogos" className="imgLogos"></img>
      </div>

      {ALL_LOGOS.map(({ img, title }, i) => (
        <Zoom key={i}>
          <div className="boxText">
            <h1>{title}</h1>
            <div className="gridContainer" onClick={() => openLightbox(img)} style={{ cursor: "pointer" }}>
              <img src={img} alt="" className="imgGrid" />
            </div>
          </div>
        </Zoom>
      ))}

      {lightbox && (
        <div className={`lightbox${visible ? " lightbox--visible" : ""}`} onClick={closeLightbox}>
          <img src={lightbox} alt="" className="lightbox__img" onClick={closeLightbox} />
        </div>
      )}
    </div>
  );
};

export default Logo;
